import { RoundButtonProps } from 'core/round-button/round-button.props';

export const RoundButtonPresets: Partial<RoundButtonProps> = {
  color: 'black',
  size: '32px',
};
